import React, { useEffect, useState } from "react";
import logo from "../../assets/testingimages/logo.png";
import Popupboxx from "../Popupbox/Popupbox";
import call from "../../assets/testingimages/projecticons/telephone-call.png";
import whatsapp from "../../assets/testingimages/projecticons/whatsapp.png";
import "./navbar.css";
import Sideicons from "../../sideicons/Sideicons";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleCourseClick = (e, path) => {
    e.preventDefault();
    window.location.href = path; // or use navigate() if using react-router
    setDropdownOpen(false);
  };

  const navbarStyle = {
    width: "100%",
    background: scrolled ? "#080c6a" : "transparent",
    padding: "3px 25px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 999,
    transition: "0.3s ease",
  };

  const containerStyle = {
    maxWidth: "1250px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const logoStyle = { width: "90px" };

  const buttonStyle = {
    padding: "10px 25px",
    background: "#c10000",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 700,
  };

  return (
    <>
      <div style={navbarStyle}>
        <div style={containerStyle}>

          {/* LOGO */}
         <a href= "/"><img src={logo} alt="Logo" style={logoStyle} /></a> 

          {/* NAV ACTIONS */}
          <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>

            <div className="course-dropdown">
              <button 
              // className="course-dropdown-btn"
               style={buttonStyle}
              >
                Courses ▾
              </button>

              <div className="course-dropdown-menu">

                <a href="/software-testing-in-chennai">Software Testing Course</a>
                <a href="/java-course-in-chennai">Java Full Stack Course</a>
                <a href="/python-course-in-chennai">Python Course</a>
                <a href="/dotnet-course-in-chennai">.NET Course</a>
                <a href="/devops-course-in-chennai">DevOps Course</a>
                <a href="/aws-course-in-chennai">AWS Course</a>
                <a href="/azure-course-in-chennai">Azure Course</a>
                <a href="/uiux-course-in-chennai">UI/UX Course</a>
                <a href="/ai-course-in-chennai">AI Course</a>
                <a href="/datascience-course-in-chennai">Data Science</a>
                <a href="/analist-course-in-chennai">Data Analysis</a>
                <a href="/frontend-course-in-chennai">Frontend Developer</a>

              </div>
            </div>

            {/* ENROLL BUTTON */}
            <button
              style={buttonStyle}
              onClick={() => setIsPopupOpen(true)}
            >
              Enroll Now
            </button>
          </div>
        </div>
      </div>

      {/* FLOATING ICONS */}
     <Sideicons/>
      <Popupboxx isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default Navbar;